import { components } from "@apiSchema";
import { iPermissionSection, PermissionSection } from "./PermissionSection";

export interface iNote {
    id: number;
    modifiedDateTime: string;
    isPublic: boolean;
    text: string;
    isOwn: boolean;
}

export class NoteData implements iPermissionSection<iNote[]> {
    static defaultData: iPermissionSection<iNote[]> = new PermissionSection<iNote[]>();

    hasData = NoteData.defaultData.hasData;
    permissionLevel = NoteData.defaultData.permissionLevel;
    data = NoteData.defaultData.data;

    constructor(data?: components["schemas"]["ChainNoteViewModelIListChainPermissionWrapper"]) {
        if (data) {
            this.mapFromApi(data);
        }
    }

    private setData(model: iPermissionSection<iNote[]>) {
        ({
            hasData: this.hasData,
            permissionLevel: this.permissionLevel,
            data: this.data
        } = model);
    }

    private sortByDate(a: iNote, b: iNote) {
        return new Date(b.modifiedDateTime).getTime() - new Date(a.modifiedDateTime).getTime()
    }

    private mapFromApi(data : components["schemas"]["ChainNoteViewModelIListChainPermissionWrapper"]) {
        this.setData(
            new PermissionSection({
                permissionLevel: PermissionSection.getPermissionLevel(data.permissionLevel),
                hasData: data.hasData ?? false,
                data: (data.data || []).sort(this.sortByDate).map(n => new Note(n)),
            })
        );
    }
}

export class Note implements iNote {
    static defaultData: iNote = {
        id: 0,
        modifiedDateTime: "",
        isPublic: false,
        text: "",
        isOwn: false,
    };

    id = Note.defaultData.id;
    modifiedDateTime = Note.defaultData.modifiedDateTime;
    isPublic = Note.defaultData.isPublic;
    text = Note.defaultData.text;
    isOwn = Note.defaultData.isOwn;

    constructor(data?: components["schemas"]["ChainNoteViewModel"]) {
        if (data) {
            this.mapFromApi(data);
        }
    }

    private setData(model: iNote) {
        ({
            id: this.id,
            modifiedDateTime: this.modifiedDateTime,
            isPublic: this.isPublic,
            text: this.text,
            isOwn: this.isOwn,
        } = model);
    }

    private mapFromApi(data: components["schemas"]["ChainNoteViewModel"]) {
        this.setData(data);
    }
}